import { variant } from 'styled-system';
import styled from 'styled-components/macro';

import Box from '../Box';

/**
 * create the variants
 */
const positionVariant = variant({
  prop: 'labelPosition',
  variants: {
    right: {
      flexDirection: 'row',
    },
    left: {
      flexDirection: 'row-reverse',
    },
    bottom: {
      flexDirection: 'column',
      textAlign: 'center',
    },
  },
});

/**
 * SpinnerWrapper
 */
const SpinnerWrapper = styled(Box)(positionVariant);

SpinnerWrapper.displayName = 'SpinnerWrapper';

export default SpinnerWrapper;
